import React from "react";
import { LazyLoadImage } from "../../../../../core/atoms";

import "./howItWorks.scss";

export const AboutOverviewHowItWorks = () => {
  const steps = [
    {
      title: "Choose your perfect destination",
      img: "https://resources.travellocal.com/about-us/about-us-how-it-works-step1.svg",
      description: "Choose the part of the world you would like to experience and fill out a simple online form.",
    },
    {
      title: "Tailor your itinerary just for you",
      img: "https://resources.travellocal.com/about-us/about-us-how-it-works-step2.svg",
      description: "One of our trusted local experts will put together a suggested itinerary personalised to your needs, hopes and budget.",
    },
    {
      title: "Book with confidence",
      img: "https://resources.travellocal.com/about-us/about-us-how-it-works-step3.svg",
      description: "Book your holiday with complete confidence that you are in safe hands from start to finish and with ABTA and ATOL protection.",
    },
  ];

  const columnClassname = "column is-8-tablet is-offset-4-tablet is-8-desktop is-offset-4-desktop";

  return (
    <div className="about-how-it-works width-wrapper">
      <div className="columns">
        <h2 className={`about-how-it-works__title ${columnClassname}`}>How it works</h2>
      </div>
      <div className="about-how-it-works__steps columns">
        <div className={columnClassname}>
          {steps.map((step, i) => {
            const className = `about-how-it-works__step`;
            const stepClassName = `${className}-${i + 1}`;
            return (
              <div className={`${className} ${stepClassName}`} key={`about-how-it-works-${i + 1}`}>
                <LazyLoadImage className="about-how-it-works__image" src={step.img} alt="" />

                <div className="about-how-it-works__content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};
